import type { HTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export function Badge({
  className,
  tone = "neutral",
  ...props
}: HTMLAttributes<HTMLSpanElement> & { tone?: "neutral" | "brand" | "success" | "warning" | "danger" }) {
  const tones = {
    neutral: "bg-muted text-muted-foreground",
    brand: "bg-primary/10 text-primary",
    success: "bg-emerald-50 text-emerald-700",
    warning: "bg-amber-50 text-amber-800",
    danger: "bg-red-50 text-red-700"
  };
  return (
    <span
      className={cn("inline-flex min-h-6 items-center rounded-full px-2.5 text-xs font-medium", tones[tone], className)}
      {...props}
    />
  );
}
